import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, message } from 'antd';

const EditButton = ({ item, edit }) => {
  if (!edit?.url) return null;
  return (
    <Link key="edit" to={edit.url(item)}>
      Edit
    </Link>
  );
};

const CopyButton = ({ item, copy }) => {
  if (!copy?.url) return null;
  return (
    <Link key="copy" to={copy.url(item)}>
      Copy
    </Link>
  );
};

const ToggleDisabledButton = ({ item, toggleDisabled }) => {
  const [loading, setLoading] = useState('');

  if (!toggleDisabled) return null;
  return (
    <Button
      type="link"
      key="state"
      loading={loading === item.id}
      onClick={async () => {
        setLoading(item.id);
        // await sleep(400);
        await toggleDisabled.onClick(item);
        setLoading('');
        message.success('Successfully updated');
      }}
    >
      {item.disabled ? 'Active' : 'Disable'}
    </Button>
  );
};

const DeleteButton = ({ item, deleteButton }) => {
  if (!deleteButton) return null;
  return (
    <Button
      type="link"
      key="state"
      onClick={() => {
        deleteButton.onClick(item);
      }}
    >
      Delete
    </Button>
  );
};

const useListActions = ({ edit, toggleDisabled, deleteButton, copy }) => ({
  item,
}) => {
  return [
    edit && <EditButton edit={edit} item={item} />,
    copy && <CopyButton copy={copy} item={item} />,
    toggleDisabled && (
      <ToggleDisabledButton item={item} toggleDisabled={toggleDisabled} />
    ),
    deleteButton && deleteButton.render ? (
      deleteButton.render(item)
    ) : (
      <DeleteButton item={item} deleteButton={deleteButton} />
    ),
  ].filter((bool) => !!bool);
};

export default useListActions;
